export default function () {
  window.scroll(window.scrollX, 0)
}